import qs from 'qs'

import instanceService from './instance'
import { AUTH_SERVER_URL } from '../helpers/constants'
import { history } from '../helpers/history'
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, SESSION_BY_ID } from '../constants/token'

let instance = instanceService.instance(AUTH_SERVER_URL)

export const authService = {
  getToken,
  logout,
  checkSession,
  workSession,
  checkWorkSession,
  getActiveCashBoxId
}

function getToken(data) {

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
    url: '/oauth/token',
    auth: {
      username: 'fNZDSWid85UC1YhV',
      password: 'PytZWmpYz6UrPHKmkHiZxwMv'
    }
  }
  return instance(options).then((response) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(response.data.access_token))
    localStorage.setItem(REFRESH_TOKEN_KEY, JSON.stringify(response.data.refresh_token))

    return response
  })
}

function logout() {

  const options = {
    method: 'DELETE',
    url: '/oauth/logout'
  }
  return instance(options).then(
    response => {
      localStorage.clear()
      sessionStorage.clear()
      history.push('/')

      return response
    }
  )
}

function checkSession() {
  let item = localStorage.getItem(ACCESS_TOKEN_KEY)
  return !!item
}

function workSession(department) {
  if (checkSession()) {
    localStorage.setItem(SESSION_BY_ID, JSON.stringify(department))

  }
}

function checkWorkSession() {
  let item = JSON.parse(localStorage.getItem(SESSION_BY_ID))
  return !!item
}

function getActiveCashBoxId() {
  return JSON.parse(localStorage.getItem(SESSION_BY_ID))
}
